<ion-header>
    <ion-toolbar>
        <ion-title>forceBonus</ion-title>
    </ion-toolbar>
</ion-header>

<ion-content>

    <ion-list>
        <ion-item>
            <ion-label>

            </ion-label>
            <ion-select [(ngModel)]="selectedBonus">
                <ion-select-option *ngFor="let x of bonusType|keyvalue" [value]="x.key">{{x.value}}</ion-select-option>
            </ion-select>
        </ion-item>

        <ion-item>
            <ion-label>Da</ion-label>
            <ion-datetime  [(ngModel)]="from"  picker-format="YYYY-MM-DD" placeholder="Select Date"></ion-datetime>
        </ion-item>
        <ion-item>
            <ion-label>A</ion-label>
            <ion-datetime [(ngModel)]="to" picker-format="YYYY-MM-DD" placeholder="Select Date"></ion-datetime>
        </ion-item>
        <ion-item>
            <ion-label>
                Utente
            </ion-label>
            <ion-select>
                <ion-select-option *ngFor="let u of users">{{u.lastname | titlecase}} {{ u.name |titlecase}}</ion-select-option>
            </ion-select>
        </ion-item>
    </ion-list>


    <div class="text-center ion-text-center">
        <ion-button [expand]="'block'" class="ion-text-center" (click)="processBonus()" *ngIf="!loading"> Applica
        </ion-button>
        <ion-button *ngIf="loading">
            <ion-spinner></ion-spinner>
        </ion-button>
    </div>
</ion-content>
